import { NgModule } from "@angular/core";

import { DiscussionEditorComponent } from "./discussion-editor.component";
import { EditableDiscussionResolver } from "../../../shared/services";
import { DiscussionEditorRoutingModule } from "./discussion-editor-routing.module";

import { SharedModule } from "../../../shared";

@NgModule({
  imports: [DiscussionEditorRoutingModule, SharedModule],
  declarations: [DiscussionEditorComponent],
  providers: [EditableDiscussionResolver],
})
export class DiscussionEditorModule {}
